import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';

interface OnChanges {
  ngOnChanges(changes: SimpleChanges): void;
}

@Component({
  selector: 'app-commitment-container',
  styleUrls: ['./commitment-container.component.css'],
  templateUrl: './commitment-container.component.html'
})
export class CommitmentContainerComponent implements OnInit, OnChanges {
  @Input() canEdit: boolean;
  @Output() commitmentSelected = new EventEmitter<string>();
  @Input() description: string;
  @Input() icon: string;
  iconConfiguration: string[];
  isCommitmentMenuVisible = false;
  @Input() isCompleted: boolean;
  @Input() isConfiguration = false;
  @Input() label: string;
  @Input() leadNumber: number;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    this.iconConfiguration = ['fal', this.icon];
  }

  ngOnInit(): void {
    this.iconConfiguration = ['fal', this.icon];
  }

  onCommitmentSelected(): void {
    if (!this.isCompleted) {
      this.commitmentSelected.emit(this.label);
    }
  }
}
